import { render, staticRenderFns } from "./NewsFive.vue?vue&type=template&id=4033bf3d&scoped=true&"
import script from "./NewsFive.vue?vue&type=script&lang=ts&"
export * from "./NewsFive.vue?vue&type=script&lang=ts&"
import style0 from "./NewsFive.vue?vue&type=style&index=0&id=4033bf3d&lang=stylus&scoped=true&"
import style1 from "./NewsFive.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4033bf3d",
  null
  
)

export default component.exports